import React from 'react';

const ExpandedComponent = ({items}) => {
    return (
        <div className='flex gap-6 items-center flex-wrap w-full'>
            {
                items.map((item,index)=> (

                    <div className={`keyValue ml-6 ${item.class}`}>
                        <div className="key">{item.title}:</div>
                        <div className="value"> {item.value || '..........'}</div>
                    </div>
                ))
            }


        </div>
    );
};

export default ExpandedComponent;